import React from "react";

import Button from "ui/Button";
import Form, { FormTextField } from "ui/Form";
import FormActions from "ui/Form/FormActions";
import FormContent from "ui/Form/FormContent";
import FormHeader from "ui/Form/FormHeader";

import useDialogFormik from "hooks/useDialogFormik";
import useSignInForm from "hooks/forms/useSignInForm";

const SignInForm = () => {
  const { initialValues, loading, signInValidator, onSubmit } = useSignInForm();
  const formik = useDialogFormik({
    initialValues,
    onSubmit,
    validationSchema: signInValidator,
  });

  return (
    <Form formik={formik}>
      <div className="sign-in-form">
        <FormHeader
          title="Log into Repo"
          subTitle="Enter your login details below"
        />
        <FormContent>
          <FormTextField name="username" label="Username" autoComplete="off" />
          <FormTextField
            name="password"
            label="Password"
            type="password"
            autoComplete="off"
          />
        </FormContent>
        <FormActions>
          <Button
            id="loggin-button"
            type="submite"
            variant="contained"
            loading={loading}
          >
            Sign In
          </Button>
        </FormActions>
      </div>
    </Form>
  );
};

export default SignInForm;
